
import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";

const InventoryLocationBreakdown = () => {
    const routes = all_routes;

    const locations = [
        {
            name: "NOIDA",
            vacant: 18,
            vacantInitiated: 5,
            occupied: 52,
            total: 75,
        },
        {
            name: "NAJAFGARH",
            vacant: 15,
            vacantInitiated: 3,
            occupied: 41,
            total: 59,
        },
        {
            name: "G. NOIDA",
            vacant: 10,
            vacantInitiated: 2,
            occupied: 33,
            total: 45,
        },
        {
            name: "DWARKA",
            vacant: 12,
            vacantInitiated: 4,
            occupied: 48,
            total: 64,
        },
        {
            name: "SHASTRI PARK",
            vacant: 8,
            vacantInitiated: 3,
            occupied: 61,
            total: 72,
        },
        {
            name: "KALKAJI",
            vacant: 7,
            vacantInitiated: 1,
            occupied: 42,
            total: 50,
        },
    ];

    return (
        <div className="page-wrapper">
            <div className="content">
                {/* Page Header */}
                <div className="page-header">
                    <div className="row">
                        <div className="col-sm-12">
                            <h3 className="page-title">Location-wise Inventory</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={routes.staffQuarter.inventory.dashboard}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item active">Locations</li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Location Cards */}
                <div className="row">
                    {locations.map((loc, index) => (
                        <div className="col-xl-4 col-md-6 col-12" key={index}>
                            <Link to={`${routes.staffQuarter.inventory.locationView}?location=${loc.name}`}>
                                <div className="card h-100 transition-transform hover-scale">
                                    <div className="card-header">
                                        <h5 className="card-title mb-0">{loc.name}</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="badge bg-danger">Vacant</span>
                                            <span className="font-weight-bold">{loc.vacant}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="badge bg-secondary">Vacant Initiated</span>
                                            <span className="font-weight-bold">{loc.vacantInitiated}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="badge bg-success">Occupied</span>
                                            <span className="font-weight-bold">{loc.occupied}</span>
                                        </div>
                                        <hr />
                                        <div className="d-flex justify-content-between">
                                            <span className="font-weight-bold">Total</span>
                                            <span className="font-weight-bold">{loc.total}</span>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default InventoryLocationBreakdown;
